import { Home, Compass, Settings } from "lucide-react";
import { useLocation, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { useDiscoverSession } from "@/contexts/DiscoverSessionContext";
import { useTranslation } from "react-i18next";

const navItems = [
  { icon: Home, labelKey: "nav.home", path: "/home" },
  { icon: Compass, labelKey: "nav.discover", path: "/discover" },
  { icon: Settings, labelKey: "nav.settings", path: "/settings" },
];

const BottomNav = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { sessionActive } = useDiscoverSession();
  const { t } = useTranslation();

  // Hide on onboarding, landing, auth pages
  // Hide on discover only when a session is active (setup screen still shows nav)
  if (location.pathname.startsWith("/onboarding") || location.pathname === "/landing" || location.pathname === "/auth" || location.pathname === "/privacy-policy" || location.pathname === "/terms-of-service" || location.pathname === "/about" || location.pathname === "/faq" || location.pathname === "/guides" || location.pathname.startsWith("/blog") || location.pathname === "/demo" || location.pathname === "/demo-end") return null;
  if (location.pathname === "/discover" && sessionActive) return null;

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-50 glass border-t border-border safe-area-bottom">
      <div className="flex items-center justify-around px-2 py-1 max-w-lg mx-auto">
        {navItems.map((item) => {
          const isActive = location.pathname === item.path;
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="relative flex flex-col items-center gap-0 px-4 py-1 rounded-xl transition-colors"
            >
              {isActive && (
                <motion.div
                  layoutId="nav-indicator"
                  className="absolute inset-0 bg-primary/10 rounded-xl"
                  transition={{ type: "spring", stiffness: 400, damping: 30 }}
                />
              )}
              <item.icon
                className={`w-5 h-5 relative z-10 transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`}
              />
              <span
                className={`text-[11px] font-medium relative z-10 transition-colors ${
                  isActive ? "text-primary" : "text-muted-foreground"
                }`}
              >
                {t(item.labelKey)}
              </span>
            </button>
          );
        })}
      </div>
    </nav>
  );
};

export default BottomNav;
